import React from "react";
import Button from "@mui/material/Button";
import PrintIcon from "@mui/icons-material/Print";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";
import "./RelatorioMedicaoPrint.css";
import { NOME_CLIENTE_DOCUMENTO } from "../Config/branding";

function numero(valor) {
  if (valor === "" || valor === null || valor === undefined) return 0;
  if (typeof valor === "number") return Number.isFinite(valor) ? valor : 0;
  const convertido = Number(String(valor).replace(/\./g, "").replace(",", "."));
  return Number.isFinite(convertido) ? convertido : 0;
}

function moeda(valor) {
  return numero(valor).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

function dataBR(valor) {
  if (!valor) return "";
  const [ano, mes, dia] = String(valor).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : valor;
}

function quantidadeLinha(linha, idades) {
  return idades.reduce((total, idade) => total + numero(linha.quantidades?.[idade]), 0);
}

export default function RelatorioMedicaoPrint({ medicao, onVoltar }) {
  useNomeArquivoPdf(medicao.codigo || "medicao");
  const idades = medicao.idadesSelecionadas || [];
  const linhas = medicao.linhas || [];
  const adicionais = (medicao.itensAdicionais || []).filter((item) =>
    !["locacao_equipamento", "consultoria"].includes(item.tipo) || item.selecionado === true ||
    String(item.valorUnitario ?? "").trim() !== ""
  );
  const totalAgenda = linhas.reduce(
    (total, linha) => total + quantidadeLinha(linha, idades) * numero(linha.valorUnitario),
    0
  );
  const totalAdicionais = adicionais.reduce(
    (total, item) => total + numero(item.quantidade) * numero(item.valorUnitario),
    0
  );

  return (
    <div className="relatorio-medicao-print">
      <div className="acoes-medicao">
        <Button startIcon={<ArrowBackIcon />} onClick={onVoltar}>Voltar</Button>
        <Button variant="contained" startIcon={<PrintIcon />} onClick={() => window.print()}>Imprimir</Button>
      </div>
      <main className="pagina-medicao">
        <table className="cabecalho-medicao">
          <tbody>
            <tr>
              <td rowSpan="2" className="logo-medicao"><LogoRelatorio alt="Logo" /></td>
              <td className="titulo-medicao">SISTEMA DE GESTÃO DA QUALIDADE</td>
              <td>Revisão 01</td>
            </tr>
            <tr><td className="titulo-medicao">PLANILHA DE MEDIÇÃO</td><td>{dataBR(medicao.data)}</td></tr>
          </tbody>
        </table>
        <div className="linha-codigo-medicao"><span><b>DATA:</b> {dataBR(medicao.data)}</span><span><b>CÓDIGO:</b> {medicao.codigo || "-"}</span></div>

        <table className="identificacao-medicao"><tbody><tr><th>EMPRESA</th><td>{medicao.cliente}</td></tr><tr><th>OBRA</th><td>{medicao.obra}</td></tr></tbody></table>

        {linhas.length > 0 && <h2 className="titulo-secao-medicao">Ruptura de corpos de prova</h2>}
        {linhas.length > 0 && <table className="itens-medicao">
          <thead>
            <tr><th rowSpan="2">Código</th><th rowSpan="2">Data da<br />Moldagem</th><th colSpan={Math.max(1, idades.length)}>Quantidade CPs x Idade</th><th rowSpan="2">VALOR<br />UNITÁRIO (R$)</th><th rowSpan="2">VALOR<br />TOTAL (R$)</th><th rowSpan="2">OBSERVAÇÃO</th></tr>
            <tr>{idades.length ? idades.map((idade) => <th key={idade}>{String(idade).padStart(2, "0")} dias</th>) : <th>-</th>}</tr>
          </thead>
          <tbody>{linhas.map((linha) => {
            const total = quantidadeLinha(linha, idades) * numero(linha.valorUnitario);
            return <tr key={linha.id}><td>{linha.codigo}</td><td>{dataBR(linha.dataMoldagem)}</td>{idades.map((idade) => <td key={idade}>{linha.quantidades?.[idade] || ""}</td>)}<td>{numero(linha.valorUnitario).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</td><td>{total.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</td><td>{linha.observacao}</td></tr>;
          })}</tbody>
        </table>}

        {linhas.length > 0 && <p className="periodo-servicos-medicao">
          Período de moldagem de {dataBR(medicao.dataInicial) || "__/__/____"} a {dataBR(medicao.dataFinal) || "__/__/____"}
        </p>}

        {linhas.length > 0 && <div className="total-medicao"><strong>VALOR PARCIAL DA MEDIÇÃO</strong><strong>{moeda(totalAgenda)}</strong></div>}

        {adicionais.length > 0 && <h2 className="titulo-secao-medicao">Outros serviços de medição</h2>}
        {adicionais.length > 0 && <table className="servicos-medicao">
          <colgroup>
            <col style={{ width: "5%" }} />
            <col style={{ width: "5%" }} />
            <col style={{ width: "70%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "10%" }} />
          </colgroup>
          <thead><tr><th>ITEM</th><th>QTE</th><th>DESCRIÇÃO</th><th>P. Unit (R$)</th><th>P. Total (R$)</th></tr></thead>
          <tbody>
            {adicionais.map((item, index) => <tr key={item.id || index}>
              <td>1.{index + 1}</td>
              <td>{numero(item.quantidade).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 3 })}</td>
              <td>
                {item.descricao || "ITEM ADICIONAL"}
                {item.tipo === "modulo_elasticidade" && item.codigosModulo?.length > 0 && <div>CÓD. {item.codigosModulo.join(", ")}</div>}
              </td>
              <td className="servico-preco">{moeda(item.valorUnitario)}</td>
              <td className="servico-preco">{moeda(numero(item.quantidade) * numero(item.valorUnitario))}</td>
            </tr>)}
            <tr className="servicos-subtotal"><th colSpan={4}>SUB-TOTAL:</th><th className="servico-preco">{moeda(totalAdicionais)}</th></tr>
          </tbody>
        </table>}

        {adicionais.length > 0 && <p className="periodo-servicos-medicao">
          <strong>Período de</strong> {dataBR(medicao.periodoOutrosServicosInicio) || "__/__/____"} <strong>a</strong> {dataBR(medicao.periodoOutrosServicosFim) || "__/__/____"}
        </p>}

        <div className="total-geral-medicao"><strong>VALOR TOTAL DA MEDIÇÃO</strong><strong>{moeda(totalAgenda + totalAdicionais)}</strong></div>
        {medicao.referenciaRelatorio && <p className="referencia-medicao">Medição conforme relatório: {medicao.referenciaRelatorio}</p>}
        {medicao.observacoes && <p className="referencia-medicao">Observações: {medicao.observacoes}</p>}
        <div className="assinatura-medicao">
          <img
            src="/Images/assinaturaLeal.png"
            alt="Assinatura de José Carlos Lemes Leal"
            style={{ display: "block", height: 35, maxWidth: "60mm", objectFit: "contain", margin: "0 auto -17px" }}
          />
          <span style={{ width: "45mm", alignSelf: "center" }}></span>
          <b>José Carlos Lemes Leal</b>
          <div>{NOME_CLIENTE_DOCUMENTO}</div>
        </div>
      </main>
    </div>
  );
}
